module.exports = __webpack_public_path__ + "img/2.1d47f21e.jpg";